export const appBannerCtaLinks = {
    vrbo: 'https://t.vrbo.io/vzOOWqKPq7',
    homeaway: 'https://t.hmwy.io/wwKd6WUPq7'
};
